import { render, staticRenderFns } from "./showIndex-skeleton.vue?vue&type=template&id=752d07ea&scoped=true&"
import script from "./showIndex-skeleton.vue?vue&type=script&lang=js&"
export * from "./showIndex-skeleton.vue?vue&type=script&lang=js&"
import style0 from "./showIndex-skeleton.vue?vue&type=style&index=0&id=752d07ea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752d07ea",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/show/skeleton/showIndex-skeleton.vue
// module id = null
// module chunks = 